export const ADMIN_ROUTES = [
  '/overview',
  '/sync',
  '/catalog',
  '/orders-payments',
  '/nova-poshta-orders',
  '/settings',
  '/settings/telegram',
  '/settings/nova-poshta',
  '/logs',
];

export const ADMIN_ROUTE_SET = new Set<string>(ADMIN_ROUTES);

export const SETTINGS_NAV_CHILDREN = [
  { key: 'settings-main', label: 'Основні налаштування', path: '/settings' },
  { key: 'settings-nova-poshta', label: 'Нова Пошта', path: '/settings/nova-poshta' },
  { key: 'settings-telegram', label: 'Telegram Mini App', path: '/settings/telegram' },
];
